// extracted by mini-css-extract-plugin
export var container = "_cx-1";
export var cornerButtonContainer = "_cx-6";
export var disabled = "_cx-2";
export var dragActive = "_cx-3";
export var fileContainer = "_cx-5";
export var hiddenInput = "_cx-4";
export var widthContainer = "_cx-0";